const useSortByLoc = (data, userLatitude, userLngitude) => {
  // sort by location
  let sortedData = JSON.parse(JSON.stringify(data));

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d; // distance returned
  }

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  for (let i = 0; i < sortedData.length; i++) {
    let distance = getDistanceFromLatLonInKm(
      parseInt(userLatitude),
      parseInt(userLngitude),
      sortedData[i]?.meta?.hp_latitude || sortedData[i]?.dealer?.latitude,
      sortedData[i]?.meta?.hp_longitude || sortedData[i]?.dealer?.longitude
    );
    // attaching returned distance from function to array elements
    sortedData[i].distance = distance;
  }

  // create an array for data without lat/lng
  let noLatLng = sortedData.filter((i) => {
    return i?.meta?.hp_latitude == "";
  });

  // remove data without lat/lng
  sortedData = sortedData.filter((i) => {
    return i?.meta?.hp_latitude !== "";
  });

  // sort data by lat/lng
  sortedData.sort(function (a, b) {
    return a.distance - b.distance;
  });

  return [...sortedData, ...noLatLng];
};

export default useSortByLoc;
